const { mapValues } = require('lodash')

const compareByKeys = {
  DISTRICT: 'district',
  SCHOOL: 'school',
  TEACHER: 'teacher',
  CLASS: 'class',
  GROUP: 'group',
  STUDENT: 'student',
  RACE: 'race',
  GENDER: 'gender',
  FRL_STATUS: 'frlStatus',
  ELL_STATUS: 'ellStatus',
  IEP_STATUS: 'iepStatus',
  HISPANIC_ETHNICITY: 'hispanicEthnicity',
}

const compareByOptionsInfo = {
  [compareByKeys.DISTRICT]: { key: 'districtId', name: 'districtName' },
  [compareByKeys.SCHOOL]: { key: 'schoolId', name: 'schoolName' },
  [compareByKeys.TEACHER]: { key: 'teacherId', name: 'teacherName' },
  [compareByKeys.CLASS]: { key: 'groupId', name: 'groupName' },
  [compareByKeys.GROUP]: { key: 'groupId', name: 'groupName' },
  [compareByKeys.STUDENT]: { key: 'studentId', name: 'studentName' },
  [compareByKeys.RACE]: {
    key: compareByKeys.RACE,
    name: compareByKeys.RACE,
  },
  [compareByKeys.GENDER]: {
    key: compareByKeys.GENDER,
    name: compareByKeys.GENDER,
  },
  [compareByKeys.FRL_STATUS]: {
    key: compareByKeys.FRL_STATUS,
    name: compareByKeys.FRL_STATUS,
  },
  [compareByKeys.ELL_STATUS]: {
    key: compareByKeys.ELL_STATUS,
    name: compareByKeys.ELL_STATUS,
  },
  [compareByKeys.IEP_STATUS]: {
    key: compareByKeys.IEP_STATUS,
    name: compareByKeys.IEP_STATUS,
  },
  [compareByKeys.HISPANIC_ETHNICITY]: {
    key: compareByKeys.HISPANIC_ETHNICITY,
    name: compareByKeys.HISPANIC_ETHNICITY,
  },
}

const EXTERNAL_SCORE_TYPES = {
  SCALED_SCORE: 'score',
  LEXILE_SCORE: 'lexileScore',
  QUANTILE_SCORE: 'quantileScore',
  PERCENTILE: 'percentile',
}

const EXTERNAL_SCORE_PREFIX = {
  [EXTERNAL_SCORE_TYPES.LEXILE_SCORE]: 'BR',
  [EXTERNAL_SCORE_TYPES.QUANTILE_SCORE]: 'EM',
}

const EXTERNAL_SCORE_SUFFIX = {
  [EXTERNAL_SCORE_TYPES.LEXILE_SCORE]: 'L',
  [EXTERNAL_SCORE_TYPES.QUANTILE_SCORE]: 'Q',
  [EXTERNAL_SCORE_TYPES.PERCENTILE]: '%ile',
}

const ANALYZE_BY_AVERAGE_SCORE_TABLE_PAGE_SIZE = 100
const ANALYZE_BY_PERFORMANCE_DISTRIBUTION_TABLE_PAGE_SIZE = 25

const sortKeys = {
  COMPARE_BY: 'compareBy',
  ASSESSMENT_: 'ASSESSMENT_',
}

const compareByMap = mapValues(compareByOptionsInfo, ({ name }) => name)

const ANALYZE_BY_KEYS = {
  AVERAGE_SCORE: 'averageScore',
  PERFORMANCE_DISTRIBUTION: 'performanceDistribution',
}

const ANALYZE_BY_OPTIONS = [
  { key: ANALYZE_BY_KEYS.AVERAGE_SCORE, title: 'Average Score' },
  {
    key: ANALYZE_BY_KEYS.PERFORMANCE_DISTRIBUTION,
    title: 'Performance Distribution',
  },
]

const tableColumnsData = [
  {
    dataIndex: sortKeys.COMPARE_BY,
    key: sortKeys.COMPARE_BY,
    align: 'left',
    fixed: 'left',
    width: 200,
    sorter: true,
  },
]

module.exports = {
  ANALYZE_BY_AVERAGE_SCORE_TABLE_PAGE_SIZE,
  ANALYZE_BY_PERFORMANCE_DISTRIBUTION_TABLE_PAGE_SIZE,
  sortKeys,
  ANALYZE_BY_KEYS,
  ANALYZE_BY_OPTIONS,
  tableColumnsData,
  compareByMap,
  compareByKeys,
  compareByOptionsInfo,
  EXTERNAL_SCORE_TYPES,
  EXTERNAL_SCORE_PREFIX,
  EXTERNAL_SCORE_SUFFIX,
}
